var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11c1.38 0 2.63-.56 3.536-1.464A4.984 4.984 0 0011 6c0-1.38-.56-2.63-1.464-3.536A4.984 4.984 0 006 1c-1.38 0-2.63.56-3.536 1.464A4.984 4.984 0 001 6c0 1.38.56 2.63 1.464 3.536A4.984 4.984 0 006 11z",
    stroke: "#A8AAAD",
    strokeWidth: 0.429,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.156v-1a1.5 1.5 0 10-1.5-1.5",
    stroke: "#A8AAAD",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.406a.625.625 0 100-1.25.625.625 0 000 1.25z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/question.6a89302e.svg";
export { SvgQuestion as ReactComponent };